module.exports = __webpack_public_path__ + "img/expired.8e0961ef.png";